import React,{ useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/incomingpage.css'
import { logDOM } from '@testing-library/react';
// Util function to generate an image with the first letter
function generateLetterImage(letter) {
  // Create a canvas element
 
 
  const canvas = document.createElement('canvas');
  canvas.width = 100; // Set width
  canvas.height = 100; // Set height

  // Get 2D context
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#53a9e5'; // Set background color
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = '#ffffff'; // Set text color
  ctx.font = '48px Arial'; // Set font size and family
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(letter.toUpperCase(), canvas.width / 2, canvas.height / 2); // Draw letter

  return canvas.toDataURL(); // Get image as data URL
}

const Incomingcallscreen = ({  onAnswer, onDecline,leadname,leadnumber,leadid,leaddate,leadowner }) => {
const [caller_name,setCallerName]=useState('')
const [caller_number,setCallerNumber]=useState('')
const [lead_detail,setLeadDetail] =useState(false)
 const ibleaddetails = useSelector((state) => state.ibleaddetails)
 
  useEffect(()=>{

    setCallerName(leadname)
    setCallerNumber(leadnumber)
   
  },[leadname,leadnumber])

  useEffect(() => {
    if (leadname !== "Unknown Name") {
      setLeadDetail(true)
    }else{
      setLeadDetail(false)
    }

  
  },)
  
  
  
  const firstLetter = leadname.charAt(0).toUpperCase();
  const letterImage = generateLetterImage(firstLetter);
 
  useEffect(() => {
    const imageEl = document.querySelector('.letter-image');
    imageEl.classList.add('animate-letter-image');
  }, []);
  return (
    <div className="incoming-call-container">
     <div className='calltye-header'>Incoming call</div>
     <img src={letterImage} alt={firstLetter} className="letter-image" />
        
      <div className="incomingcaller-info">
       <div>{caller_name}</div> 
       <div>{caller_number}</div>
       </div>
       {lead_detail && (
  <>
  <div className="incomingcaller-existinginfo">
     <div>Lead Owner : {leadowner} </div>
     <div>Lead Id : {leadid} </div>
     <div>Lead Date : {leaddate} </div>
     </div>
  </>
)  

}
 
      <div className="call-actions">
        <div className="answer-button">
        <button onClick={onAnswer} className="animate-answer" >
          <FontAwesomeIcon icon={faPhone} />
        </button>
        </div>
        
        <div className="decline-button">
        <button onClick={onDecline}>
          <FontAwesomeIcon icon={faPhone} />
        </button>
        </div>
        
      </div>
    </div>
  );
};

export default Incomingcallscreen;













// import React, { useEffect,useState } from 'react';
// import incomingaudio from '../assets/audio/ringtone.wav'
// import '../assets/css/incomingpage.css'
// const Incomingcallscreen = ({  }) => {
// const[incomingaudio,SetIncomingaudio]=useState(false);


//   useEffect(()=>{
// console.log("INboundpage UseEffect");
//   },[])

//   return (
//     <div className="incoming-call-popup">
   
//     <div className ="calltype-header">Incoming call </div>
    
//      {/* <button onClick={answercall}>Answer</button>
//      <button onClick={declinecall}>Decline</button>
//      <button onClick={onClose}>Close</button> */}
//    </div>
    
//   );
// };

// export default Incomingcallscreen;
